import { Metric } from '@models';

export const metrics: { [key: string]: Metric } = {
  time: {
    value: 0,
    unit: 'Second',
    id: 'adba92c6-ae50-4ffe-b75d-35261750931a',
  } as Metric,
  needleDriverLeftPath: {
    value: 0,
    unit: 'Integer',
    id: 'b9b3e57c-01b6-4579-be93-108b0d3fb811',
  } as Metric,
  needleDriverRightPath: {
    value: 0,
    unit: 'Integer',
    id: 'ca6af954-d9ec-4fea-9eab-903a9148af34',
  } as Metric,
};
